import React, { Fragment } from 'react'
import i18n from 'atpjs/helpers/i18n'
import { existingCustomer } from 'tve/helpers/logic'
import { NavigationItem } from './navigation_item'

const t = i18n.prefix(['components', 'navigation'], 'deep')

const steps = ['login', 'customerType', 'subject', 'branch', 'appointment', 'userForm']

const Navigation = ({ data, next }) => {
  const currentStep = data.get('step')
  const currentIndex = steps.indexOf(currentStep)
  const isExistingCustomer = existingCustomer(data)

  return (
    <div className="atp-grid-4-1 atp-hide-for-l-down">
      {currentIndex > 0 && (
        <Fragment>
          <p className="atp-h2">{t(['yourSelection'])}</p>
          <ol className="atp-navigation-side">
            {steps.map((step, index) => {
              if (currentIndex <= index) return null
              if (isExistingCustomer && step == 'customerType') return null
              return <NavigationItem key={step} step={step} next={next} data={data} />
            })}
          </ol>
        </Fragment>
      )}
    </div>
  )
}

Navigation.displayName = 'Navigation'

export default Navigation
